import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { ChartOptions } from 'chart.js/auto';
import { Chart, Colors, ChartType } from 'chart.js';

// registered once as the module loads, before any chart exists: a registration from a constructor reaches every chart
// already on the page (see the bar chart)
Chart.register(Colors);

export class RadarData {
    name: string

    constructor(name:string, public value:number, public color?:string, public comparison?:number) {
        this.name = name?(name.length > 10?name.substring(0, 9) + "..":name):'Missing name'
    }
}

@Component({
    selector: 'app-radar-chart',
    templateUrl: './radar-chart.html',
    styleUrls: ['./radar-chart.css'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class RadarChartComponent implements OnChanges {
    @Input() data: RadarData[];
    @Input() comparison: boolean
    @Input() width: number

    // Radar
    public radarChartOptions: ChartOptions<'radar'> = {
        responsive: false,
    };

    public pieChartLegend = false;
    public pieChartPlugins = [];

    labels = []
    values = []

    public radarChartType: ChartType = 'radar';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["data"]) {
            this.labels = this.data.map(d => d.name)
            this.values = this.comparison?[{label:"Project", data: this.data.map(d => d.value), backgroundColor: this.data.map(d => d.color)}, {label:"Current", data: this.data.map(d => d.comparison), backgroundColor: this.data.map(d => d.color)}]:
                [{data: this.data.map(d => d.value), backgroundColor: this.data.map(d => d.color)}]
        }
    }
}
